import React from 'react';
import { Modal } from 'react-bootstrap';
const _ = {
    find:       require('lodash/find'),
    map:        require('lodash/map'),
    some:       require('lodash/some'),
}

const TextStylerToolbar = require('@muzzylane/react-mzl/dist/TextStylerToolbar');
const ColorGrid = require('@muzzylane/react-mzl/dist/ColorGrid');


const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');

import ShortCoursePlayStore from '../../stores/ShortCoursePlayStore';

import AccessibleIcon from '../common/AccessibleIcon';
import CriteriaScores from './play/CriteriaScores';

const skillsInvolved = [
{score:50, passed: true,    subskill: {display_name: "Passed Skill"}},
{score:100,passed: false,   subskill: {display_name: "Failed Skill"}},
];

function CoachStyleEditorModal(props) {
    const colorIcon = (<span className="glyphicon glyphicon-text-color"/>);
    
    return (
        <Modal
            className="short-course-activity-details-modal"
            show={true}
            keyboard
            autoFocus
            enforceFocus={false}
            restoreFocus={false}
            backdrop={false}
            animation={false}
            //container={mountNode}
            onHide={props.closeHandler}
            aria-labelledby={props.modalTitleId}
        >
            <Modal.Header
                closeButton
                closeLabel={Strings['en'].common.CLOSE}
                onHide={props.closeHandler}
            >
                <Modal.Title id={props.modalTitleId}>{props.modalTitle}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="coach-style-editor">
                    <div className="coach-area">
                        <div className="coach-action-display criteria-scores-editor">
                            <CriteriaScores skillsInvolved={skillsInvolved} criteriaScoresStyle={props.criteriaScoresStyle} reportPhase={ShortCoursePlayStore.REPORT_CARD_PHASE.END}/>
                        </div>
                    </div>
                    <div className="coach-style-editor-controls">
                        <div className="row">
                            <label>Criteria Score Style:</label>
                            <div className="text-styler-toolbar-wrapper">
                                <TextStylerToolbar app={props.app} noBackgroundColor enableAlign={false} 
                                    data={props.criteriaScoresStyle || {}}
                                    onChange={props.onChangeTextStyle} 
                                    defaultFont='Inter' />
                            </div>
                        </div>
                        {/*<div className="row">
                            <label>Coach Background Color:</label>
                            <div className="colorgrid-wrapper">
                                <ColorGrid app={props.app} icon={colorIcon} value={props.coachBgColor} onChange={props.onChangeCoachBackgroundColor}/>
                            </div>
                        </div>
                        */}
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
            </Modal.Footer>
        </Modal>
    );
} // CoachStyleEditorModal

export default CoachStyleEditorModal;